const COOLDOWN_DELAY = 500;

/**
 * Exposes:
 * computed property
 *  sendAllowed — can be used to enable-disable send button
 * methods
 *  startSendingForm — to call just before sending form
 *  finishSendingForm — to call right after sending, in "finally" block
 */
export default {
  data() {
    return {
      _sending: false,
      _cooling: false,
    };
  },
  computed: {
    sendAllowed() {
      return !this.$data._sending && !this.$data._cooling;
    },
  },
  watch: {
    '$data._sending'(newVal) {
      if (newVal) {
        this.$data._cooling = true;
        setTimeout(() => {
          this.$data._cooling = false;
        }, COOLDOWN_DELAY);
      }
    },
  },
  methods: {
    startSendingForm() {
      if (!this.sendAllowed) return false;
      this.$data._sending = true;
      return true;
    },
    finishSendingForm() {
      this.$data._sending = false;
    },
  },
};
